export const DIMENSION = {
  D: 'D',
  E: 'E',
  G: 'G',
};
